export default __webpack_public_path__ + "static/media/1.156dc2f5.png";